exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".wbList {\n  padding: 10px !important;\n}\n", ""]);

// exports
